import { CODING_VISIT_TYPE_LABELS } from '../constants/codingVisitTypes';
import type { CodingVisit } from '../services/rogerDocApi';

/**
 * Returns the display label for a visit type code (e.g. "SOC (PT)" for "SOCPT").
 */
export const getVisitTypeLabel = (code: string): string =>
  CODING_VISIT_TYPE_LABELS[code] ?? code;

/**
 * Returns the display label for coding status (e.g. "Codes Available" for COMPLETED).
 */
export const getMedicalCodingStatusLabel = (status: string): string => {
  switch (status) {
    case 'COMPLETED':
      return 'Codes Available';
    case 'FAILED':
      return 'Failed';
    case 'CANCELLED':
      return 'Incomplete Data\nAction Required';
    case 'WAITING_FOR_EVAL':
      return 'Waiting for Evaluation';
    default:
      return 'In Progress';
  }
};

/**
 * Document status booleans for a coding visit (Order/F2F Attached and Signed).
 * Used by the table UI and by the Excel export.
 */
export function getDocumentStatusBooleans(visit: CodingVisit): {
  orderAttached: boolean;
  orderSigned: boolean;
  f2fAttached: boolean;
  f2fSigned: boolean;
} {
  const tags = visit.tags || {};

  return {
    orderAttached: !!tags.home_health_order_attached,
    orderSigned: !!tags.home_health_order_signed,
    f2fAttached: !!tags.face_to_face_attached,
    f2fSigned: !!tags.face_to_face_signed,
  };
}

/**
 * Helper to get branch name from clinics data
 */
export const getBranchName = (
  branchId: string | null | undefined,
  clinics: import('../services/rogerDocApi').RogerDocClinic[]
): string | null => {
  if (!branchId) return null;
  for (const clinic of clinics) {
    const branch = clinic.branches?.find(b => b.id === branchId);
    if (branch) return branch.name;
  }
  return branchId;
};
